module.exports = __webpack_public_path__ + "static/ivana_puzak_perikic-bb3f44e43946cd98f82b48f06527909a.png";